module.exports = __webpack_public_path__ + "b908edaecfb2ef51ac70b6bf7457ef2c.svg";